import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const currentLanguage = i18n.language;

  return (
    <div className="flex items-center space-x-2">
      <Globe className="h-4 w-4 text-gray-600" />
      <div className="flex bg-gray-100 rounded-md p-1">
        <button
          onClick={() => changeLanguage('en')}
          className={`px-3 py-1 text-sm font-medium rounded-md transition-colors ${
            currentLanguage === 'en' || currentLanguage.startsWith('en')
              ? 'bg-white text-gray-900 shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          EN
        </button>
        <button
          onClick={() => changeLanguage('pl')}
          className={`px-3 py-1 text-sm font-medium rounded-md transition-colors ${
            currentLanguage === 'pl' || currentLanguage.startsWith('pl')
              ? 'bg-white text-gray-900 shadow-sm'
              : 'text-gray-600 hover:text-gray-900'
          }`}
        >
          PL
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
